import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { LinkedService } from './linkedservice';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';

// Workspace, item and any path prefix come from the connection's DSR path, so this model holds no type properties.
@Metamodel.model({
    name: ModelConstants.oneLakeFileLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.OneLakeFileLinkedService_DisplayText),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.OneLakeFileLinkedService_DisplayText)
    ]
})
export class OneLakeFileLinkedService extends LinkedService {
    public static readonly MODEL: IModel;
}
